const computeReduction = (experience, adultSeats, childSeats) => {
   //all currency infos needed to build prices on list/popups
  const currencyInfos = {
    locale: document.body.dataset.currencyLocale !== '' ? document.body.dataset.currencyLocale.replace("_", "-") : 'en-US',
    rate: document.body.dataset.currencyRate,
    iso: document.body.dataset.currencyIso
  };

  const reductionElement = experience.querySelector('.reduction-infos');
  if(reductionElement){
    const totalSeats = adultSeats + childSeats;
    const pricePerAdultInEuros = reductionElement.dataset.reductionPricePerAdult;
    const pricePerChildInEuros = reductionElement.dataset.reductionPricePerChild;

    let priceBeforeReduction = 0;

    if (reductionElement.dataset.reductionUseGroupPricing === 'true') {
      const groupsPricing = JSON.parse(reductionElement.dataset.reductionGroupsPricing);
      groupsPricing.forEach(group => {
        if (totalSeats >= group.from_persons && totalSeats <= group.to_persons) {
          priceBeforeReduction = group.price;
        }
      });
    } else {
      priceBeforeReduction = (adultSeats * pricePerAdultInEuros) + (childSeats * pricePerChildInEuros);
    }

    let priceAfterReduction = priceBeforeReduction - reductionElement.dataset.reductionAmount;
    let amountLeftOnGC = 0;
    if(priceAfterReduction <= 0){
      amountLeftOnGC = Math.abs(priceAfterReduction);
      priceAfterReduction = 0;
    }

    let showIncludedWithGiftCard = false;
    let showAmountLeftOnGiftCard = false;
    let showHigherRate = false;

    if(amountLeftOnGC === 0 && reductionElement.dataset.reductionType === 'giftcard' && priceAfterReduction === 0){
      showIncludedWithGiftCard = true;
    }
    else if(amountLeftOnGC > 0 && reductionElement.dataset.reductionType === 'giftcard'){
      showAmountLeftOnGiftCard = true;
    }
    else if(amountLeftOnGC == 0 && priceAfterReduction > 0){
      showHigherRate = true;
    }

    let hidePriceAfterReduction = amountLeftOnGC == 0 && priceAfterReduction <= 0 && reductionElement.dataset.reductionType === 'giftcard';

    const includedWithGiftCardElement = experience.querySelector('.included-with-gift-card');
    const amountLeftOnGiftCardElement = experience.querySelector('.amount-left-on-gift-card');
    const higherRateElement = experience.querySelector('.higher-rate');

    if(includedWithGiftCardElement && amountLeftOnGiftCardElement && higherRateElement){
      //reset all to hidden
      includedWithGiftCardElement.classList.add('hidden');
      amountLeftOnGiftCardElement.classList.add('hidden');
      higherRateElement.classList.add('hidden');

      if(showIncludedWithGiftCard){
        includedWithGiftCardElement.classList.remove('hidden');
        amountLeftOnGiftCardElement.classList.add('hidden');
        higherRateElement.classList.add('hidden');
      }
      if(showAmountLeftOnGiftCard){
        const amountLeftOnGiftCardTextElement = amountLeftOnGiftCardElement.querySelector('.amount-left-on-gift-card-text');
        if(amountLeftOnGiftCardTextElement){
          const formattedAmountLeftOnGC = new Intl.NumberFormat(currencyInfos.locale, {
            style: 'currency',
            currency: 'EUR'
          }).format(amountLeftOnGC);

          amountLeftOnGiftCardTextElement.textContent = amountLeftOnGiftCardTextElement.dataset.text.replace('{0}', formattedAmountLeftOnGC);
        }

        amountLeftOnGiftCardElement.classList.remove('hidden');
        includedWithGiftCardElement.classList.add('hidden');
        higherRateElement.classList.add('hidden');
      }
      if(showHigherRate){
        higherRateElement.classList.remove('hidden');
        includedWithGiftCardElement.classList.add('hidden');
        amountLeftOnGiftCardElement.classList.add('hidden');
      }

      const priceAfterReductionElement = reductionElement.querySelector('.price-after-reduction');
      if(priceAfterReductionElement){
        priceAfterReductionElement.textContent = new Intl.NumberFormat(currencyInfos.locale, {
          style: 'currency',
          currency: 'EUR'
        }).format(priceAfterReduction);
        if(hidePriceAfterReduction || showIncludedWithGiftCard){
          priceAfterReductionElement.classList.add('hidden');
        }
        else{
          priceAfterReductionElement.classList.remove('hidden');
        }
      }

      const priceBeforeReductionElement = reductionElement.querySelector('.price-before-reduction');
      if(priceBeforeReductionElement){
        priceBeforeReductionElement.textContent = new Intl.NumberFormat(currencyInfos.locale, {
          style: 'currency',
          currency: 'EUR'
        }).format(priceBeforeReduction);

        if(priceAfterReduction <= 0 || showIncludedWithGiftCard){
          priceBeforeReductionElement.classList.add('hidden');
        }
        else{
          priceBeforeReductionElement.classList.remove('hidden');
        }
      }
    }
  }
}

export { computeReduction };
